/* eslint-disable import/no-anonymous-default-export */
export default {
    fam:{
        semibold:'FiraCode-SemiBold',
        bold:'Montserrat-Bold',
        regular:'FiraCode-Regular',
        LightItalic:'Montserrat-LightItalic',
        Thin:"Montserrat-Thin",
    },
    color:{
        grey:"rgb(83,86,90)",
        blue:"rgb(0,156,207)",
        white:"#f3f3f3",
    }
} 